module.exports = __webpack_public_path__ + "p4_img9.jpg?6275264b2b121f5c0ee9b3f4bfa9f959";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img9.jpg
// module id = 116
// module chunks = 0